import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastService {


  constructor(private toastr: ToastrService) { 
    toastr.toastrConfig.maxOpened = 1;
    toastr.toastrConfig.preventDuplicates = true;

  }

  success(msg: string) {
    this.toastr.success(
      msg, '', {
        timeOut: 3000,
        positionClass: 'toast-bottom-center'
      }
    );
  }

  error(msg: string) {
    this.toastr.error(
      msg, '', {
        timeOut: 3000,
        positionClass: 'toast-bottom-center'
      }
    );
  }

  info(msg: string) {
    this.toastr.info(
      msg, '', {
        timeOut: 3000,
        positionClass: 'toast-bottom-center'
      }
    );
  }

  warning(msg: string) {
    this.toastr.warning(
      msg, '', {
        timeOut: 3000,
        positionClass: 'toast-bottom-center'
      }
    );
  }

}
